/**
 * Stat Glyphs
 *
 * The entire emoji allowlist for the app. CLAUDE.md Hard Rule 4 used to ban
 * emoji outright; it now allows a fixed, small set, used only to flag a
 * stat, a player, or a genuinely crucial piece of information — never as
 * decoration and never inside a sentence. Nothing outside this file is
 * permitted anywhere in the app's UI chrome.
 *
 * Each glyph maps to exactly one meaning, always. They appear only in
 * structured UI slots — a risk chip, a trend cell, a table header — never
 * inside prose, and never in text Claude generates (the assertion that
 * strips emoji from Claude's output is unchanged; this allowlist is for
 * UI chrome only).
 *
 * Max one glyph per player row. Use `pickGlyph` when more than one flag is
 * true — it returns the single most severe glyph, in this priority order:
 * injury > locked > cold streak > top pick > hot streak.
 */

export const STAT_GLYPHS = {
  injury:    '🩹', // injury flag — an OUT/IR/GTD/questionable status
  trendUp:   '📈', // trending up — a hot streak
  trendDown: '📉', // trending down — a cold streak
  topPick:   '⭐', // top pick — JAI's #1 ranked recommendation
  locked:    '🔒', // locked / plan-gated — a feature above the user's plan
}

const SEVERITY_ORDER = ['injury', 'locked', 'trendDown', 'topPick', 'trendUp']

// `flags` — an object of { injury, trendUp, trendDown, topPick, locked }
// booleans. Returns the glyph for the single most severe true flag, or null.
export function pickGlyph(flags = {}) {
  for (const key of SEVERITY_ORDER) {
    if (flags[key]) return STAT_GLYPHS[key]
  }
  return null
}
